var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2926",
    fillRule: "evenodd",
    d: "M15.93 0C17.072 0 18 .94 18 2.094v25.812C18 29.06 17.071 30 15.93 30H2.37C1.23 30 .3 29.06.3 27.906V2.094C.3.94 1.23 0 2.37 0Zm0 1.808H2.37a.29.29 0 0 0-.284.286v25.812c0 .155.13.286.283.286h13.562c.153 0 .283-.13.283-.286V2.094a.29.29 0 0 0-.283-.286ZM9.6 23.7a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4m2.106-19.5c.328 0 .594.201.594.45 0 .243-.254.44-.572.45H7.494c-.328 0-.594-.201-.594-.45 0-.243.254-.44.572-.45z"
  })));
};
export default SvgPhone;